import request from '@/utils/request'
const apiPath = '/sys/sysMenu'
const sysMenuApi = {
  /**
   * 新增【菜单】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【菜单】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【菜单】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【菜单】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【菜单】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【菜单】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【菜单】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  getRouters() {
    return request.get(`${apiPath}/getRouters`)
  },
   /**
   * 获取角色菜单列表
   */
    getRoleRouters(id){
      return request.get(`${apiPath}/getRoleRouters/${id}`)
    },
}
export default sysMenuApi
